import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100%;

  border-radius: 0px 0px 8px 8px;

  display: flex;
  flex-direction: column;
  gap: 5px;

  background-color: #565c6a;

  padding: 4px;

  @media screen and (max-height: 750px) {
    padding: 3px;
    gap: 4px;
  }
`;

export default Container;
